<script>
import { mapState } from 'vuex'

export default {

  computed: {
    ...mapState('auth', {
      permissoes: state => state.usuarioLogado.permissoes,
      cargo: state => state.usuarioLogado.perfilSelecionado.codigo
    })
  },

  methods: {
    hasPermissao (codigo) {
      if (this.permissoes && this.permissoes.length > 0) {
        return !!this.permissoes.find(permissao => permissao.codigo === codigo)
      }
      return false
    },

    hasRegra (regras, codigo) {
      return !!regras.find(regra => regra.codigo === codigo)
    },

    isChefeSetor () {
      return this.cargo.includes('GERENTE') || this.cargo.includes('COORDENADOR') || this.cargo.includes('PRESIDENTE') || this.cargo.includes('DIRETOR')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/analise/PermissaoHelper.vue